@if(naturvardesbedomning){
@let kontraktReadonly = kontraktReadonly$ | async;
@if(naturvardesomradeNotFound){
<div>
    <rask-validation-message-row
        type="error"
        message="Naturvärdesområde kunde inte fastställas, pröva igen vid ett senare tillfälle">
    </rask-validation-message-row>
</div>
}

@if( naturvardesbedomning.naturvardesbedomningKalla === "Fil" ||
naturvardesbedomning.naturvardesbedomningKalla === "Riskbedömning-Fil"){
<rask-kontrakt-dokument
    #dokument
    [dokumenttyp]="blobStorageDokumentTypNvbBilaga"
    [isForKontrakt]="false"
    (fileUpload)="onFileUpload()"
    [deleteFileEnabled]="true"
    [requireAtLeastOneFile]="requireAtLeastOneFile"
    [multiple]="true"
    [atgardId]="atgard.id"></rask-kontrakt-dokument>
}
@else if(naturvardesbedomning.naturvardesbedomningKalla === "Formulär" || nvbKravsEj() === false){
@if (isNorraSverige) {
<div>
    <rask-nvbnorra-sverige [readonly]="kontraktReadonly" [naturvardesbedomning]="naturvardesbedomning"
        (updateDTO)="updateDTO()"></rask-nvbnorra-sverige>
</div>
}

@if (isMellerstaSverige) {
<div>
    <rask-nvbmellersta-sverige [readonly]="kontraktReadonly" [naturvardesbedomning]="naturvardesbedomning"
        (updateDTO)="updateDTO()"></rask-nvbmellersta-sverige>
</div>
}

@if (isSodraSverige) {
<div>
    <rask-nvbsodra-sverige [readonly]="kontraktReadonly" [naturvardesbedomning]="naturvardesbedomning"
        (updateDTO)="updateDTO()"></rask-nvbsodra-sverige>
</div>
}
}
@else if(naturvardesbedomning.naturvardesbedomningKalla === "Riskbedömning"){
<rask-forenklad-riskbedomning
    [isReadOnly]="kontraktReadonly"
    [naturvardesbedomning]="naturvardesbedomning"
    (updateDTO)="updateDTO()"></rask-forenklad-riskbedomning>
}
@else{

@if(isNvbRequired()){
<rask-atgard-nvb-leveransvirke
    [isReadOnly]="kontraktReadonly"
    [naturvardesbedomning]="naturvardesbedomning">
</rask-atgard-nvb-leveransvirke>
}
@else {
<div class="d-flex" [formGroup]="form">
    <rask-radiobutton-group
        label="Kräver åtgärden naturvärdesbedömning?"
        [verticalLayout]="true"
        formControlName="nvbKravsEj"
        [buttons]="[{ key: false, value: 'Ja' }, { key: true, value: 'Nej' }]">
    </rask-radiobutton-group>
    <rask-button
        class="ms-auto"
        color="secondary"
        (click)="continue()"
        [disabled]="!form.controls.nvbKravsEj.valid || kontraktReadonly || naturvardesbedomning.utfordDatum">
        Fortsätt
    </rask-button>
</div>
}
}

@if(naturvardesbedomning.utfordDatum){
<div>
    @if(nvbKravsEj() === true){
    <strong>Naturvärdesbedömning krävs ej</strong>
    }
    @else if (naturvardesbedomning.naturvardesbedomningKalla === "Riskbedömning-Fil" ||
    naturvardesbedomning.naturvardesbedomningKalla === "Riskbedömning") {
    <strong>Riskbedömning utförd</strong>
    }
    @else {
    <strong>Naturvärdesbedömning utförd</strong>
    }
    <br />
    <strong>{{naturvardesbedomning.utfordDatum | date:'shortDate'}} - {{naturvardesbedomning.utfordAv}}</strong>
</div>
}
@else if(cancelButtonVisible()){
<div>
    <rask-button color="secondary" negative (click)="cancel()">
        Avbryt
    </rask-button>
</div>
}
}